module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-6a9c1206b3a339b0602ed45d19f89a0a.png";